const combineClassNames = (...args) => {
  if (args.length === 0) {
    return '';
  }
  const classNames = args[0] instanceof Array ? args[0] : args;
  return classNames.filter(x => x).join(' ');
};

export default combineClassNames;
